import { render, staticRenderFns } from "./calendar-element-type.vue?vue&type=template&id=565b5caf"
import script from "./calendar-element-type.vue?vue&type=script&lang=js"
export * from "./calendar-element-type.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports